var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.publications)?_c('div',{staticClass:"column is-10"},[_c('div',{staticClass:"has-text-centered p-7 is-size-3 has-text-gray is-italic"},[_vm._v(" Coming soon ~ ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }